import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@mui/styles';
import ReactDOM from 'react-dom';

const useStyles = makeStyles(() => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)', // desenfoque sutil
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300,
  },
  spinner: {
    color: '#3F63AC', // tu violeta o el color que prefieras
    marginBottom: 16,
  },
  texto: {
    fontSize: '1.1rem',
    color: '#333',
    fontWeight: 500,
    fontFamily: "'Segoe UI', sans-serif",
  },
}));

const LoadingOverlay = ({ isLoading }) => {
  const classes = useStyles();

  if (!isLoading) return null;

  return ReactDOM.createPortal(
    <div className={classes.overlay}>
      <CircularProgress size={60} className={classes.spinner} />
      <span className={classes.texto}>Cargando...</span>
    </div>,
    document.body
  );
};

export default LoadingOverlay;
